import React, { useEffect, useState, useCallback } from "react";
import ReactPaginate from "react-paginate";
import api from "../../axiosConfig";
import {
  Table,
  Button,
  InputGroup,
  FormControl,
  Container,Col,
} from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import "../pagination.css";

function FirmaList() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchParams, setSearchParams] = useSearchParams();
  const search = searchParams.get("q") || "";

  // Căutare + paginare sincronizate cu backend-ul
  const fetchItems = useCallback(async () => {
    const skip = currentPage * itemsPerPage;
    try {
      const res = await api.get("/firma", {
        params: {
          search,
          skip,
          limit: itemsPerPage,
        },
      });
      setItems(res.data.items);
      setTotalCount(res.data.total);
      // console.log("🧾 Răspuns complet:", res);
      // console.log("📦 Date din res.data:", res.data);
    } catch (err) {
      console.error("Eroare la încărcare:", err);
    }
  }, [search, currentPage, itemsPerPage]);

  useEffect(() => {
    fetchItems();
  }, [fetchItems]);

  const handleSearchChange = (e) => {
    setSearchParams({ q: e.target.value });
    setCurrentPage(0); // reset pagină când cauți
  };

  const handleDelete = async (id) => {
    if (window.confirm("Sigur dorești să ștergi înregistrarea cu ID " + id + "?")) {
      try {
        await api.delete(`/firma/${id}`);
        fetchItems(); // reîncărcăm lista după ștergere
      } catch (err) {
        alert("Eroare la ștergere.");
      }
    }
  };

  const pageCount = Math.max(1, Math.ceil(totalCount / itemsPerPage));

  return (
    <Container className="mt-4">
      <h2>Lista Firma</h2>
      <Col className="text-end">
      <Button className="mb-3" onClick={() => navigate("/firma/create")}>
        Adaugă
      </Button>
      </Col>
      <InputGroup className="mb-3">
        <FormControl
          placeholder="Caută după denumire"
          value={search}
          onChange={handleSearchChange}
        />
        {search && (
          <Button variant="outline-danger" onClick={() => setSearchParams({})}>
            Curăță
          </Button>
        )}
      </InputGroup>

      <div className="mb-3">
        <label>
          Rânduri pe pagină:&nbsp;
          <select
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(parseInt(e.target.value));
              setCurrentPage(0);
            }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
          </select>
        </label>
      </div>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>ID</th>
              <th>bxid</th>
              <th>bxdenumire</th>
              <th>bxcodfiscal</th>
              <th>bxadresa</th>
              <th>bxregcom</th>
              <th>bxtara</th>
              <th>bxtel</th>
              <th>bxfax</th>
              <th>bxemail</th>
              <th>platitor_tva</th>
              <th>tva_la_incasare</th>
              <th>bxoras</th>
              <th>bxjudet_id</th>
              <th>bxsector_id</th>
              <th>bxcodpostal</th>
              <th>bxfirst_date</th>
              <th>bxlast_date</th>
              <th>versiune_baza</th>
              <th>bxcod_judet_san</th>
              <th>bxsector</th>
              <th>bxcap_social</th>
              <th>zecimale_cantitate</th>
              <th>zecimale_pret</th>
              <th>judet_str</th>
              <th>m_token</th>
              <th>m_token_refresh</th>
              <th>m_token_dataexp</th>
              <th>cu_conturi_900</th>
              <th>cont_taxa_vama_id</th>
              <th>cont_tva_vama_id</th>
              <th>cont_comision_vama_id</th>
              <th>preturi_catalog_cu_tva</th>
              <th>cont_banca1</th>
              <th>nume_banca1</th>
              <th>cont_banca2</th>
              <th>nume_banca2</th>
              <th>atribut</th>
              <th>contor_visible</th>
              <th>santier_visible</th>
              <th>medic_visible</th>
              <th>Acțiuni</th>
          </tr>
        </thead>
        <tbody>
          {items.map((it) => (
            <tr key={it.bxid}>
              <td>{it.bxid}</td>
              <td>{it.bxid}</td>
              <td>{it.bxdenumire}</td>
              <td>{it.bxcodfiscal}</td>
              <td>{it.bxadresa}</td>
              <td>{it.bxregcom}</td>
              <td>{it.bxtara}</td>
              <td>{it.bxtel}</td>
              <td>{it.bxfax}</td>
              <td>{it.bxemail}</td>
              <td>{it.platitor_tva}</td>
              <td>{it.tva_la_incasare}</td>
              <td>{it.bxoras}</td>
              <td>{it.bxjudet_id}</td>
              <td>{it.bxsector_id}</td>
              <td>{it.bxcodpostal}</td>
              <td>{it.bxfirst_date}</td>
              <td>{it.bxlast_date}</td>
              <td>{it.versiune_baza}</td>
              <td>{it.bxcod_judet_san}</td>
              <td>{it.bxsector}</td>
              <td>{it.bxcap_social}</td>
              <td>{it.zecimale_cantitate}</td>
              <td>{it.zecimale_pret}</td>
              <td>{it.judet_str}</td>
              <td>{it.m_token}</td>
              <td>{it.m_token_refresh}</td>
              <td>{it.m_token_dataexp}</td>
              <td>{it.cu_conturi_900}</td>
              <td>{it.cont_taxa_vama_id}</td>
              <td>{it.cont_tva_vama_id}</td>
              <td>{it.cont_comision_vama_id}</td>
              <td>{it.preturi_catalog_cu_tva}</td>
              <td>{it.cont_banca1}</td>
              <td>{it.nume_banca1}</td>
              <td>{it.cont_banca2}</td>
              <td>{it.nume_banca2}</td>
              <td>{it.atribut}</td>
              <td>{it.contor_visible}</td>
              <td>{it.santier_visible}</td>
              <td>{it.medic_visible}</td>
              <td>
                <Button
                  size="sm"
                  onClick={() => navigate(`/firma/${it.bxid}`)}
                >
                  Editează
                </Button>{" "}
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleDelete(it.bxid)}
                >
                  Șterge
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <ReactPaginate
        previousLabel={"← Înapoi"}
        nextLabel={"Înainte →"}
        pageCount={pageCount}
        forcePage={currentPage}
        onPageChange={(event) => setCurrentPage(event.selected)}
        containerClassName={"pagination justify-content-center"}
        pageClassName={"page-item"}
        pageLinkClassName={"page-link"}
        previousClassName={"page-item"}
        previousLinkClassName={"page-link"}
        nextClassName={"page-item"}
        nextLinkClassName={"page-link"}
        activeClassName={"active"}
      />
    </Container>
  );
}

export default FirmaList;
